import React from "react";
import { Box, Button, Pagination, TableRow, TableCell } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

export default function CustomPagination({
  page,
  setPage,
  count,
  rowsPerPage,
  colSpan = 7,
}) {
  const totalPages = Math.ceil(count / rowsPerPage);

  return (
    <TableRow>
      <TableCell colSpan={colSpan}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            padding: "8px",
          }}
        >
          {/* PREVIOUS BUTTON */}
          {page !== 0 ? (
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Button
                variant="outlined"
                startIcon={
                  <ArrowBackIcon
                    sx={{ color: page === 0 ? "#a2a2a2" : "#414651" }}
                  />
                }
                disabled={page === 0}
                onClick={() => setPage(page - 1)}
                sx={{
                  borderRadius: "12px",
                  textTransform: "none",
                  color: page === 0 ? "#a2a2a2" : "#414651",
                  borderColor: "#d0d0d0",
                }}
              >
                Previous
              </Button>
            </Box>
          ) : (
            <Box sx={{ width: "110px" }} />
          )}

          {/* PAGE NUMBERS */}
          <Pagination
            page={page + 1}
            onChange={(e, value) => setPage(value - 1)}
            count={totalPages}
            siblingCount={1}
            boundaryCount={1}
            shape="rounded"
            hidePrevButton
            hideNextButton
          />

          {/* NEXT BUTTON */}
          {page + 1 !== totalPages ? (
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Button
                variant="outlined"
                endIcon={
                  <ArrowForwardIcon
                    sx={{
                      color: page + 1 === totalPages ? "#a2a2a2" : "#414651",
                    }}
                  />
                }
                disabled={page + 1 === totalPages}
                onClick={() => setPage(page + 1)}
                sx={{
                  borderRadius: "12px",
                  textTransform: "none",
                  color: page + 1 === totalPages ? "#a2a2a2" : "#414651",
                  borderColor: "#d0d0d0",
                }}
              >
                Next
              </Button>
            </Box>
          ) : (
            <Box sx={{ width: "110px" }} />
          )}
        </Box>
      </TableCell>
    </TableRow>
  );
}
